import { useLocation } from "react-router-dom";
import { useRef, useMemo } from "react";

const routeOrder = ["/dashboard", "/properties"];

function getRouteIndex(path: string) {
  const idx = routeOrder.findIndex(
    (r) => path === r || path.startsWith(r + "/")
  );
  return idx === -1 ? 0 : idx;
}

export function PageTransition({ children }: { children: React.ReactNode }) {
  const pathname = useLocation().pathname;
  const prevPathname = useRef(pathname);
  const directionRef = useRef<"left" | "right">("left");

  // Memoize direction calculation
  const animClass = useMemo(() => {
    if (pathname !== prevPathname.current) {
      const prevIndex = getRouteIndex(prevPathname.current);
      const nextIndex = getRouteIndex(pathname);
      directionRef.current = nextIndex >= prevIndex ? "left" : "right";
      prevPathname.current = pathname;
    }
    return directionRef.current === "left"
      ? "animate-page-in-left-fast"
      : "animate-page-in-right-fast";
  }, [pathname]);

  return (
    <div key={pathname} className={animClass}>
      {children}
    </div>
  );
}
